import "./src/styles/global.css"

export const onClientEntry = async () => {
  if (typeof window === "undefined") return;

  if ("serviceWorker" in navigator) {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    } catch (e) {}
  }
};

